import { useContext, useEffect } from "react";
import { useState } from "react";
import { CategoryContext } from "./Navbar";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function NavCategories() {
  const navigate = useNavigate()
  const {
    setShowCategory,
    categories, } = useContext(CategoryContext);
  const [active, setActive] = useState('');
  const {t, i18n} = useTranslation()


  const handleCategory = (e) => {
    setShowCategory(true);

    setActive(e)
  }
  const handleCategoryout
    = (e) => {
      setShowCategory(false);
      setActive(e)
    }

  return (
    <div className="nav-categories container ">
      <ul className="">
        {categories?.map((cat, index) => (<li key={index} className={`${active === cat.name && 'active'}`}
          onMouseEnter={() => { handleCategory(cat.name); }}
          onMouseOut={() =>
            setTimeout(() => { handleCategoryout(cat.name) }, 900)
          }
          onClick={() => {
            navigate(`/c/${cat._id}`)
          }}>{i18n.language == "en" ? cat.name : cat.nameAr}</li>))}
      </ul>
    </div>
  )
}
export default NavCategories;